import type {
  LaboratoryManagers,
  LaboratoryPermissionType,
  UserPermission,
  UserPermissionProfile,
} from "@/contracts/permissions";
import { getData, putData } from "./apiClient";

export const setUserPermissions = async (
  token: string | null,
  laboratoryId: string,
  email: string,
  permissions: LaboratoryPermissionType[],
): Promise<LaboratoryPermissionType[]> => {
  return putData<LaboratoryPermissionType[]>(
    token,
    `/laboratories/${laboratoryId}/users/${encodeURIComponent(email)}/permissions`,
    permissions,
  );
};

export const fetchLaboratoryUsers = async (token: string | null, laboratoryId: string): Promise<UserPermission[]> => {
  return getData<UserPermission[]>(token, `/laboratories/${laboratoryId}/permissions`);
};

export const fetchLaboratoryManagers = async (token: string | null): Promise<LaboratoryManagers[]> => {
  return getData<LaboratoryManagers[]>(token, "/laboratories/managers");
};

export const fetchUserPermissions = async (token: string | null, email: string): Promise<UserPermissionProfile> => {
  const raw = await getData<UserPermissionProfile>(token, `/users/${encodeURIComponent(email)}/permissions`);
  return {
    isUserAdmin: raw.isUserAdmin ?? false,
    laboratoryPermissions: (raw.laboratoryPermissions ?? []).map((lp) => ({
      laboratoryId: lp.laboratoryId,
      permissions: lp.permissions,
    })),
  };
};
